import { Pipe, PipeTransform } from '@angular/core';

import { Question } from '../models/question.model';

@Pipe({
  name: 'qOptionTitle',
  pure: true
})
export class QuestionOptionTitlePipe implements PipeTransform {
  transform(optionId: string, qId: string, questions: Question[]): string {
    return questions.find((q) => q.id === qId)?.options.find((opt) => opt.id === optionId)?.text;
  }
}
